import { useSearchParams } from 'react-router-dom';

export function useSearchParam(param: string) {
  const [searchParams] = useSearchParams();
  return searchParams.get(param);
}
